<template>
  <div class="external-document-info">
    <table class="w-full">
      <tr>
        <td class="w-1/2">№</td>
        <td class="w-1/2">{{ documentData.document.number }}</td>
      </tr>
      <tr v-if="documentData.document.description">
        <td class="w-1/2">{{ t("sign.description") }}</td>
        <td class="w-1/2">{{ documentData.document.description }}</td>
      </tr>
      <tr>
        <td class="w-1/2">{{ t("sign.expiresAt") }}</td>
        <td class="w-1/2">
          {{ format(parseISO(documentData.expiresAt), "dd.MM.yyyy HH:mm") }}
        </td>
      </tr>
      <tr>
        <td class="w-1/2">{{ t("sign.recipient") }}</td>
        <td class="w-1/2">
          {{ documentData.recipientName }}
        </td>
      </tr>
      <tr>
        <td class="w-1/2">{{ t("sign.recipientIinBin") }}</td>
        <td class="w-1/2">
          {{ documentData.recipientIinBin }}
        </td>
      </tr>
      <tr>
        <td class="w-1/2">{{ t("sign.status") }}</td>
        <td class="w-1/2">
          {{ documentData.status }}
        </td>
      </tr>
      <tr v-if="documentData.deniedComment">
        <td class="w-1/2">{{ t("sign.deniedComment") }}</td>
        <td class="w-1/2">
          {{ documentData.deniedComment }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import { t } from "@/i18n";

export default {
  methods: { parseISO, format },
  data: () => ({
    t,
  }),
  props: ["documentData"],
};
</script>

<style scoped>
td {
  padding: 5px 10px;
}
tr:nth-of-type(odd) {
  background: #e1e1e1;
}
tr:last-child {
  border-bottom: none;
}
tr {
  border-bottom: 1px solid #ddd;
}
@media (max-width: 768px) {
  .external-document-info table,
  .external-document-info tr,
  .external-document-info td {
    display: block;
    width: 100%;
    overflow-wrap: anywhere;
  }
  td:first-child {
    color: #64748b;
  }
}
</style>
